import { atom } from 'recoil'

export const PWAInstallOpenState = atom<boolean>({
    key: 'pwaInstalOpen',
    default: false,
})

export const zIndexMapAtom = atom<Record<string, number>>({
    key: 'zIndexMapAtom',
    default: {
        top: 50,
    },
})
